__turbopack_context__.v({
  "container": "VhP_Ja_container",
  "inputContainer": "VhP_Ja_inputContainer",
});
